import React from 'react';
import Icon from '@mui/material/Icon';
import arrowLeft from '@assets/arrow-left.svg';

function ArrowLeft() {
  return (
    <Icon>
      <img alt="arrow" src={arrowLeft} style={{ display: 'block' }} />
    </Icon>
  );
}

export default ArrowLeft;
